export class CurrentLiffInfo {
  public browserLanguage: string;
  public sdkVersion: string;
  public lineVersion: string;
  public isInClient: boolean;
  public isLoggedIn: boolean;
  public deviceOS: boolean;
}
